<template>
    <div class="main-container">
        <Breadcrumb>
            <template slot="breadcrumb">
                <div class="breadcrumb_box text-center">
                    <h2 class="breadcrumb-title">Privacy Policy</h2>
                </div>
            </template>
        </Breadcrumb>

        <div class="section-space--pt_90 section-space--pb_120">
            <div class="container">
                <div class="legal-content">
                    <h1>PRIVACY POLICY</h1>
                    <p class="last-updated">Last updated: January 27, 2026</p>

                    <p>
                        This Privacy Policy describes how DualBit s.r.l. ("we", "us", or "our") collects, uses,
                        and discloses your personal information when you visit our website
                        <a href="https://dualb.it" target="_blank" rel="noopener">https://dualb.it</a>
                        (the "Service").
                    </p>
                    <p>
                        By using the Service, you agree to the collection and use of information in accordance
                        with this policy.
                    </p>

                    <h2>1. Data Controller</h2>
                    <p>The entity responsible for the processing of your data is:</p>
                    <p>
                        DualBit s.r.l. VAT / P.IVA: 03716620368 REA: MO 411645 Address: Modena (MO), Italy
                        Email: <a href="mailto:dualbit@dualb.it">dualbit@dualb.it</a>
                        PEC: <a href="mailto:dualbit@pec.it">dualbit@pec.it</a>
                    </p>

                    <h2>2. Types of Data We Collect</h2>
                    <p>We collect two main types of information to provide and improve our Service:</p>

                    <h3>A. Personal Data (Contact Form)</h3>
                    <p>
                        When you use our "Contact Us" form to request a quote, ask a question, or say hello, we
                        may ask you to provide us with certain personally identifiable information. This may include,
                        but is not limited to:
                    </p>
                    <ul>
                        <li>First name and last name</li>
                        <li>Email address</li>
                        <li>The content of your message</li>
                    </ul>
                    <p>
                        Purpose: We use this data solely to respond to your inquiries, provide quotes, or manage
                        the business relationship with you. We do not sell this data to third parties.
                    </p>

                    <h3>B. Usage Data &amp; Tracking (Google Analytics)</h3>
                    <p>
                        We use Google Analytics (and Google Tag Manager) to monitor and analyze the use of our
                        Service. This helps us understand how visitors interact with our website so we can improve
                        the user experience.
                    </p>
                    <p>Google Analytics collects information such as:</p>
                    <ul>
                        <li>Your computer's Internet Protocol (IP) address (often anonymized)</li>
                        <li>Browser type and version</li>
                        <li>The pages of our Service that you visit</li>
                        <li>The time and date of your visit</li>
                        <li>The time spent on those pages</li>
                        <li>Unique device identifiers</li>
                    </ul>
                    <p>Cookies: Cookies are files with a small amount of data which may include an anonymous unique identifier.</p>
                    <ul>
                        <li>
                            Google Analytics Cookies: These are used to track usage behavior. You can opt-out of having
                            your activity on the Service available to Google Analytics by installing the Google Analytics
                            Opt-out Browser Add-on.
                        </li>
                    </ul>
                    <p>
                        For more information on the privacy practices of Google, please visit the Google Privacy &amp; Terms
                        <a href="https://policies.google.com" target="_blank" rel="noopener">web page</a>.
                    </p>

                    <h2>3. How We Use Your Data</h2>
                    <p>DualBit s.r.l. uses the collected data for the following purposes:</p>
                    <ul>
                        <li>To provide and maintain the Service (ensuring the website works correctly).</li>
                        <li>To provide customer support (responding to your messages via the contact form).</li>
                        <li>To analyze usage (using Google Analytics to see which pages are popular and improve our content).</li>
                        <li>To detect, prevent, and address technical issues.</li>
                    </ul>

                    <h2>4. Data Retention</h2>
                    <ul>
                        <li>
                            Contact Data: We retain your personal inquiries for as long as necessary to fulfill the purpose of your
                            message (e.g., providing a quote or completing a project) and to comply with legal obligations
                            (e.g., tax laws).
                        </li>
                        <li>
                            Analytics Data: Usage data is generally retained for a shorter period, except when this data is used to
                            strengthen the security or to improve the functionality of our Service.
                        </li>
                    </ul>

                    <h2>5. Third-Party Service Providers</h2>
                    <p>
                        We may employ third-party companies and individuals to facilitate our Service ("Service Providers"),
                        to provide the Service on our behalf, or to assist us in analyzing how our Service is used.
                    </p>
                    <ul>
                        <li>Google Analytics: As described above, for traffic analysis.</li>
                    </ul>
                    <p>
                        These third parties have access to your Personal Data only to perform these tasks on our behalf and are
                        obligated not to disclose or use it for any other purpose.
                    </p>

                    <h2>6. Data Security</h2>
                    <p>
                        The security of your data is important to us. We strive to use commercially acceptable means to protect
                        your Personal Data, but remember that no method of transmission over the Internet, or method of electronic
                        storage, is 100% secure.
                    </p>

                    <h2>7. Your Data Protection Rights (GDPR)</h2>
                    <p>
                        If you are a resident of the European Economic Area (EEA), you have certain data protection rights.
                        DualBit s.r.l. aims to take reasonable steps to allow you to correct, amend, delete, or limit the use of
                        your Personal Data.
                    </p>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access: Request copies of your personal data.</li>
                        <li>Rectification: Request that we correct any information you believe is inaccurate.</li>
                        <li>Erasure: Request that we delete your personal data ("Right to be forgotten").</li>
                        <li>Restrict Processing: Request that we restrict the processing of your personal data.</li>
                        <li>Object: Object to our processing of your personal data.</li>
                    </ul>
                    <p>
                        To exercise any of these rights, please contact us at
                        <a href="mailto:dualbit@pec.it">dualbit@pec.it</a>
                        or our general contact email.
                    </p>

                    <h2>8. Links to Other Sites</h2>
                    <p>
                        Our Service may contain links to other sites that are not operated by us (e.g., links to our social media
                        profiles or partners). If you click on a third-party link, you will be directed to that third party's site.
                        We strongly advise you to review the Privacy Policy of every site you visit.
                    </p>

                    <h2>9. Changes to This Privacy Policy</h2>
                    <p>
                        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new
                        Privacy Policy on this page and updating the "Last updated" date at the top.
                    </p>

                    <h2>Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, please contact us:</p>
                    <ul>
                        <li>By email: <a href="mailto:dualbit@dualb.it">dualbit@dualb.it</a> or <a href="mailto:dualbit@pec.it">dualbit@pec.it</a></li>
                        <li>
                            By visiting the contact section on our website:
                            <a href="https://dualb.it" target="_blank" rel="noopener">https://dualb.it</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <FooterMain class="border-top" />
        <OffcanvasSearchBox />
        <OffCanvasMobileMenu />
    </div>
</template>

<script>
    import Breadcrumb from '@/components/Breadcrumb'
    import FooterMain from '@/components/FooterMain'
    import OffcanvasSearchBox from '@/components/OffcanvasSearchBox'
    import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'

    export default {
        name: 'PrivacyPolicy',
        components: {
            Breadcrumb,
            FooterMain,
            OffcanvasSearchBox,
            OffCanvasMobileMenu
        },
        metaInfo: {
            title: 'Dualbit - Privacy Policy',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
    }
</script>

<style scoped>
    .legal-content {
        max-width: 860px;
        margin: 0 auto;
    }

    .legal-content h1 {
        font-size: 30px;
        margin-bottom: 10px;
    }

    .legal-content h2 {
        font-size: 22px;
        margin-top: 28px;
        margin-bottom: 12px;
    }

    .legal-content h3 {
        font-size: 18px;
        margin-top: 22px;
        margin-bottom: 10px;
    }

    .legal-content p {
        margin-bottom: 14px;
    }

    .legal-content ul {
        padding-left: 20px;
        margin-bottom: 14px;
    }

    .legal-content li {
        margin-bottom: 6px;
    }

    .last-updated {
        color: #666;
        font-size: 14px;
        margin-bottom: 24px;
    }
</style>
